import { createRouter, createWebHistory } from "vue-router"
import HomeView from "../views/HomeView.vue"
import Detail from "../views/detail.vue"
import { getUserInfo } from "@/api/api"
const routes = [
    {
        path: "/",
        name: "home",
        component: HomeView
    },
    {
        path: "/detail",
        name: "detail",
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: Detail
    },
    {
        path: "/all",
        name: "all",
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ "../views/teamKpi.vue")
    },
    {
        path: "/change",
        name: "change",
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ "../views/change.vue")
    },
    {
        path: "/surname-manage",
        name: "surname-manage",
        component: () => import(/* webpackChunkName: "surname" */ "../views/SurnameManage.vue")
    },
    {
        path: "/usage-guide",
        name: "usage-guide",
        component: () => import("../views/UsageGuide.vue")
    }
]

const router = createRouter({
    history: createWebHistory(),
    routes
})

const resetStateAndToLogin = () => {
    const Process = process.env.NODE_ENV
    let path
    console.log(Process)
    if (Process == "development") {
        path =
            "https://auth.successfulmatch.com/realms/ms/protocol/openid-connect/auth?response_type=code&client_id=kpitool&scope=openid profile roles email&redirect_uri=http://localhost:8080/"
    } else {
        path =
            "https://auth.successfulmatch.com/realms/ms/protocol/openid-connect/auth?response_type=code&client_id=kpitool&scope=openid profile roles email&redirect_uri=https://kpiweb.reflect.today/"
    }

    // const path =
    //   'https://auth.successfulmatch.com/realms/ms/protocol/openid-connect/auth?response_type=code&client_id=knowledge-base&scope=openid%20profile%20roles%20email&redirect_uri=http://kno.reflect.today/'
    // router.push({ path: '/login' })
    window.location.href = path
}
const urlParams = new URLSearchParams(window.location.search)
let code = urlParams.get("code")

router.beforeEach(async (to, from, next) => {
    let token = localStorage.getItem("token")
    let role = localStorage.getItem("role")

    // console.log(token, "tokentokentokentoken")
    // debugger;
    const Process = process.env.NODE_ENV
    if (!code && !token) {
        resetStateAndToLogin()
        return
    }
    if (!token) {
        const Formda = new FormData()
        Formda.append("code", code)
        Formda.append("type", Process === "development" ? 0 : 1)
        const data = { code: code, type: Process === "development" ? 0 : 1 }
        await getUserInfo(Formda)
            .then((res) => {
                console.log(res)
                if (res.code === "8200") {
                    localStorage.setItem("userinfo", JSON.stringify(res.data))
                    localStorage.setItem("token", res.data.token)
                    localStorage.setItem("role", res.data.role)
                    if (res.data.role != 1 && res.data.role != 2) {
                        if (to.path !== "/detail" && to.path !== "/usage-guide") {
                            // 避免重复跳转
                            next({ path: "/detail" })
                        } else {
                            next() // 如果已经在目标路径，继续导航
                        }
                    } else {
                        next()
                    }
                } else {
                    resetStateAndToLogin()
                }
            })
            .catch((err) => {
                // resetStateAndToLogin();
            })
    } else {
        // console.log(from, to, next);
        if (role != "1" && role != "2") {
            if (to.path !== "/detail" && to.path !== "/usage-guide") {
                // 避免重复跳转
                next({ path: "/detail" })
            } else {
                next() // 如果已经在目标路径，继续导航
            }
        } else {
            next()
        }
    }

})
export default router
